import { computed, Injectable, signal } from '@angular/core';
import { Authority, AuthorityKey, PERMISSION, User } from '@shared/types/rbac';
import _ from 'lodash';
@Injectable({
  providedIn: 'root',
})
export class RbacService {
  private readonly _user = signal<Readonly<User>>(null);
  private readonly authorityKey = computed(() => {
    if (!this._user()) return '';
    return AuthorityKey[this._user().roleType] ?? '';
  });

  getUser() {
    return this._user();
  }

  setUser(user: User) {
    this._user.set(Object.freeze(user));
  }

  isGranted(permissions: PERMISSION | PERMISSION[], user: User = this._user()) {
    if (!user || !this.authorityKey()) return false;

    const authoriry: Authority = user[this.authorityKey()];
    if (_.isArray(permissions)) {
      return permissions.some((permission) => _.get(authoriry, permission, false));
    }
    return _.get(authoriry, permissions, false);
  }
}
